import React from "react";
import { Lock, ShieldCheck, AlertCircle, CheckCircle2 } from "lucide-react";

const BANNER_STYLES = {
  locked: {
    bg: "bg-[#faf7f2]",
    border: "border-amber-200",
    icon: Lock,
    iconColor: "text-amber-500",
  },
  pending: {
    bg: "bg-blue-50",
    border: "border-blue-200",
    icon: AlertCircle,
    iconColor: "text-blue-500",
  },
  restricted: {
    bg: "bg-red-50/60",
    border: "border-red-200",
    icon: ShieldCheck,
    iconColor: "text-red-400",
  },
  info: {
    bg: "bg-emerald-50",
    border: "border-emerald-200",
    icon: CheckCircle2,
    iconColor: "text-emerald-500",
  },
};

export default function EntitlementBanner({ type = "locked", title, message, action, onAction }) {
  const style = BANNER_STYLES[type] || BANNER_STYLES.locked;
  const Icon = style.icon;

  return (
    <div className={`rounded-xl border ${style.border} ${style.bg} px-4 py-3 flex items-center gap-3`}
      data-testid={`entitlement-banner-${type}`}>
      <div className={`p-2 rounded-lg border ${style.border} bg-white/60`}>
        <Icon className={`h-4 w-4 ${style.iconColor}`} />
      </div>
      <div className="flex-1 min-w-0">
        {title && <p className="text-xs font-bold text-[#333]">{title}</p>}
        {message && <p className="text-[11px] text-[#666] mt-0.5">{message}</p>}
      </div>
      {action && onAction && (
        <button onClick={onAction}
          className="shrink-0 px-3 py-1.5 rounded-lg border border-[#e8e0d0] bg-white text-[10px] font-bold text-[#333] hover:bg-[#faf7f2] transition-colors"
          data-testid={`entitlement-action-${type}`}>
          {action}
        </button>
      )}
    </div>
  );
}

export function LockedOverlay({ children, locked = false, reason, role }) {
  if (!locked) return children;
  return (
    <div className="relative" data-testid="locked-overlay">
      <div className="opacity-40 pointer-events-none select-none blur-[1px]">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-white/90 backdrop-blur-sm rounded-xl border border-amber-200 shadow-lg px-6 py-4 text-center max-w-xs">
          <Lock className="h-5 w-5 text-amber-500 mx-auto mb-2" />
          <p className="text-xs font-bold text-[#333]">{reason || "Feature Locked"}</p>
          <p className="text-[10px] text-[#888] mt-1">
            {role === "investor" && "Complete accreditation to unlock this feature."}
            {role === "borrower" && "Submit your first application to access this feature."}
            {role === "lender" && "Your account is pending approval."}
            {!role && "Contact your administrator for access."}
          </p>
        </div>
      </div>
    </div>
  );
}
